import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "../lib/assets";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Programs", href: "#programs" },
  { label: "Gallery", href: "#gallery" },
  { label: "Register", href: "#register" },
  { label: "Contact", href: "#contact" },
];

export const Header = ({ onDonate }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Our Hovse Foundation" className="h-12 w-12 object-contain" />
          <span className="font-display text-2xl text-white hidden sm:block">
            OUR HOVSE <span className="text-[#C4F542]">FOUNDATION</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm uppercase tracking-widest text-zinc-300 hover:text-[#C4F542] transition-colors duration-200"
            >
              {n.label}
            </a>
          ))}
          <button
            data-testid="header-donate-btn"
            onClick={onDonate}
            className="bg-[#C4F542] text-black font-bold uppercase tracking-widest text-sm py-3 px-6 hover:bg-white transition-colors duration-300"
          >
            Donate
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base uppercase tracking-widest text-zinc-200 hover:text-[#C4F542]"
              >
                {n.label}
              </a>
            ))}
            <button
              data-testid="mobile-donate-btn"
              onClick={() => {
                setOpen(false);
                onDonate();
              }}
              className="mt-2 bg-[#C4F542] text-black font-bold uppercase tracking-widest text-sm py-3 px-6"
            >
              Donate
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
